import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SiteResponse } from 'src/app/core/models/sites-management/site-response';
import { TemplatesService } from 'src/app/core/services/api/templates.service';

@Component({
  selector: 'app-dynamic-template-iframe',
  templateUrl: './dynamic-template-iframe.component.html',
  styleUrls: ['./dynamic-template-iframe.component.scss']
})
export class DynamicTemplateIframeComponent implements OnInit, OnChanges {
  @Input() siteData:SiteResponse;
  @Input() ifView:string;
  @Input() scrollTo:string;
  @Input() navigation:string;
  @Input() configVersion:string; 
  @Input() isExpanded: boolean = false; 

  trackId:string = "";
  url:string = "";
  /** Permiso de vista previa del borrador; hasta tenerlo no se carga el iframe. */
  previewToken = '';

  constructor(private sanitizer: DomSanitizer, private templates: TemplatesService) { }

  ngOnInit(): void {
   this.trackId = this.generateRandomCode(8);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const siteId = this.siteData?.id;
    if (changes['siteData'] && siteId) {
      this.templates.previewToken(siteId).subscribe({ next: token => { if (this.siteData?.id === siteId) this.previewToken = token; } });
    }
  }

  /*ngOnChanges(changes: SimpleChanges): void {
    if (changes['navigation'] && !changes['navigation'].firstChange) {
      this.trackId = this.generateRandomCode(8);
    }
  }*/

  getShopUrl(): string {
    // Build URL based on currently selected page (navigation)
    // Default to /home when navigation is undefined or contains the word "home"
    const base = this.siteData?.sub_domain || '';

    // Determine desired page path
    let pagePath = '/home';
    if (this.navigation && !this.navigation.toLowerCase().includes('home')) {
      // ensure leading slash and replace possible double dashes/underscores
      pagePath = `/${this.navigation}`;
    }

    this.url = this.templates.previewUrl(base, pagePath, this.previewToken, this.trackId);

    return this.url;
  }

  generateRandomCode(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < length; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }
}
